import tty from 'tty';
import os from 'os';
import Vue from 'vue';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

var localPageData = {
  props: {
    localPageData: {
      type: Object,
      required: false
    }
  },
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  }
};

var entry = {
  mixins: [localPageData],
  props: {
    entryData: {
      type: Object,
      required: true
    }
  }
};

var location = {
  data: function data() {
    return {
      coords: null,
      coordsBoundaries: {
        topLeft: null,
        bottomRight: null,
        rotatedTopLeft: null,
        rotatedBottomRight: null
      },
      positioningEngine: null
    };
  },
  // two lines
  // for getters
  computed: {
    locationParams: function locationParams() {
      if (this.pageData.System && !isNaN(this.pageData.DiffNorth) && this.pageData.Coords.topLeft && this.pageData.Coords.bottomRight) {
        return {
          system: this.pageData.System,
          diffNorth: this.pageData.DiffNorth,
          topLeft: this.pageData.Coords.topLeft,
          bottomRight: this.pageData.Coords.bottomRight
        };
      }

      return null;
    }
  },
  methods: {
    initLocationSystem: function initLocationSystem(params) {
      var _this = this;

      if (!this.$xp.positioning) return; // return if positioning plugin is not installed

      this.initCoordsData(params);

      switch (params.system.toLowerCase()) {
        case 'gps':
          this.positioningEngine = this.$xp.positioning.getEngine('GPS');

          if (this.$xp.tracker) {
            this.$xp.tracker.subscribe(this.positioningEngine.parsePositionAndNotify.bind(this.positioningEngine));
            this.positioningEngine.startListeningToTracker();
          } else {
            this.positioningEngine.start();
          }

          this.positioningEngine.subscribe(this.setUtmStandPointIndicator);
          this.$once('hook:beforeDestroy', function () {
            if (_this.$xp.tracker) {
              _this.$xp.tracker.unsubscribe(_this.positioningEngine.parsePositionAndNotify.bind(_this.positioningEngine));

              _this.positioningEngine.stopListeningToTracker();
            } else {
              _this.positioningEngine.stop();
            } // console.log

          });
          break;

        case 'pseudo':
          {
            var pseudoEngine = this.$xp.positioning.getEngine('Pseudo');
            var pseudoCoords = pseudoEngine.getLastPosition();
            pseudoCoords && this.setUtmStandPointIndicator(pseudoCoords);
            break;
          }

        case 'wlan':
          {
            var fraunhoferEngine = this.$xp.positioning.getEngine('FraunhoferPosition');
            fraunhoferEngine.subscribe(this.setUtmStandPointIndicator);
            break;
          }
      }
    },
    initCoordsData: function initCoordsData(params) {
      if (params.topLeft && params.bottomRight) {
        console.log('initCoordsData(', params, ')');
        this.coordsBoundaries.topLeft = {
          easting: params.topLeft.easting,
          northing: params.topLeft.northing
        };
        this.coordsBoundaries.bottomRight = {
          easting: params.bottomRight.easting,
          northing: params.bottomRight.northing
        };
        this.coordsCenter = {
          easting: this.coordsBoundaries.topLeft.easting + (this.coordsBoundaries.bottomRight.easting - this.coordsBoundaries.topLeft.easting) / 2,
          northing: this.coordsBoundaries.topLeft.northing + (this.coordsBoundaries.bottomRight.northing - this.coordsBoundaries.topLeft.northing) / 2
        };
        this.alphaRotation = -params.diffNorth * (Math.PI / 180);
        console.log('alphaRotation:', this.alphaRotation);
        this.coordsBoundaries.rotatedTopLeft = this.rotateUTM(this.coordsBoundaries.topLeft);
        this.coordsBoundaries.rotatedBottomRight = this.rotateUTM(this.coordsBoundaries.bottomRight); // this.pixelsInMeter = this.width / (this.coordsBoundaries.bottomRight.easting - this.coordsBoundaries.topLeft.easting)

        console.log('initCoordsData(', params, ') boundries=', this.coordsBoundaries, ', center:', this.coordsCenter);
      } else {
        console.log('initCoordsData(', params, ') attributes missing');
      }
    },
    rotateUTM: function rotateUTM(utmCoords) {
      if (this.alphaRotation) {
        return Object.assign({}, utmCoords, {
          easting: this.coordsCenter.easting + Math.cos(this.alphaRotation) * (utmCoords.easting - this.coordsCenter.easting) - Math.sin(this.alphaRotation) * (utmCoords.northing - this.coordsCenter.northing),
          northing: this.coordsCenter.northing + Math.sin(this.alphaRotation) * (utmCoords.easting - this.coordsCenter.easting) + Math.cos(this.alphaRotation) * (utmCoords.northing - this.coordsCenter.northing)
        });
      } else {
        return Object.assign({}, utmCoords);
      }
    },
    getFixedAccuracy: function getFixedAccuracy(utmCoords) {
      var MIN_QUALITY_ACCURACY = 2.5; // 5m for quality = 0

      var MAX_QUALITY_ACCURACY = 35; // 15m for quality = 1

      var DEFAULT_PERCENT_ACCURACY = 0.1; // 10% of the biggest dimension

      var mapWidth = Math.abs(this.coordsBoundaries.rotatedTopLeft.easting - this.coordsBoundaries.rotatedBottomRight.easting);
      var mapHeight = Math.abs(this.coordsBoundaries.rotatedTopLeft.northing - this.coordsBoundaries.rotatedBottomRight.northing);
      var maxAccuracy = Math.min(mapHeight, mapWidth) * 0.5;
      var minAccuracy = Math.max(mapWidth, mapHeight) * 0.05;

      if (utmCoords.accuracy) {
        // if accuracy is set make sure its not bigger then the max and min accuracy
        return Math.max(minAccuracy, Math.min(utmCoords.accuracy, maxAccuracy)) * 2; // radius * 2 = width and height
      } else if (utmCoords.quality >= 0 && utmCoords.quality <= 1) {
        // if quality is between 0 and 1 then accuracy is between MIN_QUALITY_ACCURACY to MAX_QUALITY_ACCURACY and min and max accuracy
        var accuracyFromQuality = MAX_QUALITY_ACCURACY - (MAX_QUALITY_ACCURACY - MIN_QUALITY_ACCURACY) * utmCoords.quality;
        return Math.max(minAccuracy, Math.min(accuracyFromQuality, maxAccuracy)) * 2;
      } else {
        // if neither is set (PseudoLocation), accuracy is on default value
        return Math.max(mapWidth, mapHeight) * DEFAULT_PERCENT_ACCURACY;
      }
    },
    setUtmStandPointIndicator: function setUtmStandPointIndicator(utmCoords) {
      var point = this.$el.querySelector('.js-stand-point'); // console.log('setUtmStandPointIndicator()', utmCoords, this.geoData)

      var shouldSetIndicator = utmCoords.easting && utmCoords.northing && this.coordsBoundaries.rotatedBottomRight.easting >= utmCoords.easting && utmCoords.easting >= this.coordsBoundaries.rotatedTopLeft.easting && this.coordsBoundaries.rotatedTopLeft.northing >= utmCoords.northing && utmCoords.northing >= this.coordsBoundaries.rotatedBottomRight.northing;
      console.log('shouldSetIndicator', shouldSetIndicator);

      if (shouldSetIndicator) {
        var fixedAccuracy = this.getFixedAccuracy(utmCoords);
        this.coords = utmCoords;
        var rotatedCoords = this.rotateUTM(utmCoords);
        var topPercentage = 100 * Math.abs(rotatedCoords.northing - this.coordsBoundaries.rotatedTopLeft.northing) / Math.abs(this.coordsBoundaries.rotatedBottomRight.northing - this.coordsBoundaries.rotatedTopLeft.northing);
        var leftPercentage = 100 * Math.abs(rotatedCoords.easting - this.coordsBoundaries.rotatedTopLeft.easting) / Math.abs(this.coordsBoundaries.rotatedBottomRight.easting - this.coordsBoundaries.rotatedTopLeft.easting);
        var accuracyWidth = Math.round(fixedAccuracy / Math.abs(this.coordsBoundaries.rotatedBottomRight.easting - this.coordsBoundaries.rotatedTopLeft.easting) * 100);
        var accuracyHeight = Math.round(fixedAccuracy / Math.abs(this.coordsBoundaries.rotatedBottomRight.northing - this.coordsBoundaries.rotatedTopLeft.northing) * 100);
        point.style.width = accuracyWidth + '%';
        point.style.height = accuracyHeight + '%';
        point.style.top = topPercentage + '%';
        point.style.left = leftPercentage + '%';
        point.style.display = 'block';
        this.$emit('stand-point-indicator-position-changed', {
          topPercentage: topPercentage,
          leftPercentage: leftPercentage
        }); // console.log('setUtmStandPointIndicator show(easting=', utmCoords.easting, ', left=', Math.round(leftPercentage), '%, northing=', utmCoords.northing, ', top=', Math.round(topPercentage), '%)')
      } else {
        point.style.display = 'none';
        console.log('setUtmStandPointIndicator hide');
      }
    }
  }
};

/**
 * Debouncing enforces that a function not be called again until a certain amount of time has passed without it being called.
 * see http://demo.nimius.net/debounce_throttle/
 *
 * @param {function} fn function to debounce
 * @param {integer} wait in milliseconds
 * @param {boolean} immediate whether to execute immediately
 */
function debounce (fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var immediate = arguments.length > 2 ? arguments[2] : undefined;
  var timeout;

  function
    /* ...args */
  debounced() {
    var _this = this;

    var args = arguments; // eslint-disable-line

    var later = function later() {
      timeout = null;

      if (!immediate) {
        fn.apply(_this, args);
      }
    };

    clearTimeout(timeout);

    if (immediate && !timeout) {
      fn.apply(this, args);
    }

    timeout = setTimeout(later, wait);
  }

  debounced.cancel = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

var tapCounter = 0;
var singleClickTimer = null;
var script = {
  name: 'PanzoomMap',
  mixins: [location],
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    startCenter: {
      type: Object,
      required: true
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: Infinity
    },
    startZoom: {
      type: Number
    },
    // allowZoom: {
    //   type: Boolean,
    //   default: true
    // },
    doubleTapZoomRatio: {
      type: Number,
      default: 1.5
    },
    inHomePage: {
      type: Boolean,
      default: false
    },
    geoData: {
      type: Object
    }
  },
  data: function data() {
    return {
      transform: {
        x: 0,
        y: 0,
        scale: 1,
        minX: 0,
        maxX: 0,
        minY: 0,
        maxY: 0,
        minScale: 1,
        maxScale: 1
      },
      mapSize: {
        width: 0,
        height: 0
      },
      wrapperSize: {
        width: 0,
        height: 0
      },
      referenceImageWidth: 1920,
      // fixedZoomRatio: null,
      scale100Percent: 0,
      locationPathAngle: 0,
      isInteracting: false,
      lastTouchData: null,
      hasMoved: false,
      isAutoScrolling: false,
      isInitialized: false,
      showHints: true
    };
  },
  computed: {
    devicePixelRatio: function devicePixelRatio() {
      return window.devicePixelRatio;
    },
    transformMatrix: function transformMatrix() {
      // console.log('transformMatrix() x=', this.transform.x, ', y=', this.transform.y, ', scale=', this.transform.scale)
      return "matrix(".concat(this.transform.scale, ", 0, 0, ").concat(this.transform.scale, ", ").concat(this.transform.x, ", ").concat(this.transform.y, ")");
    },
    allowZoom: function allowZoom() {
      if (this.maxZoom !== this.minZoom) return true;else return false;
    }
  },
  created: function created() {
    this.removeIsInteractingAfterWheel = debounce(this.removeIsInteractingAfterWheel);
  },
  mounted: function mounted() {
    this.mapElement = this.$el.querySelector('.js-map');
    this.wrapperSize = this.getWrapperSize();

    if (this.wrapperSize.width > 0) {
      this.init();
    }

    this.$on('stand-point-indicator-position-changed', this.onStandPointIndicatorPositionChanged); // else: wait for call to reInit()
    // console.log('devicePixelRatio', window.devicePixelRatio)
  },
  beforeDestroy: function beforeDestroy() {
    this.$off('stand-point-indicator-position-changed', this.onStandPointIndicatorPositionChanged);
  },
  methods: {
    isStandPointIndicatorInViewport: function isStandPointIndicatorInViewport() {
      var point = this.$el.querySelector('.js-stand-point span');

      if (!point) {
        return false;
      }

      var bounding = point.getBoundingClientRect();
      return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    getWrapperSize: function getWrapperSize() {
      return this.mapElement.parentElement.getBoundingClientRect().toJSON();
    },
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var transform, pseudoCoords, x, y;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.pageId = _this.$xp.content.pageData.ID; // this.fixedZoomRatio = this.$xp.settings.mergedSettings.zoomRatio

                _this.mapSize.width = _this.width / devicePixelRatio;
                _this.mapSize.height = _this.height / devicePixelRatio; // console.log(`this.wrapperSize = (${this.wrapperSize.width}, ${this.wrapperSize.height})`)
                // console.log(`this.mapSize = (${this.mapSize.width}, ${this.mapSize.height})`)

                _this.transform.minScale = Math.min(_this.wrapperSize.width / _this.mapSize.width, _this.wrapperSize.height / _this.mapSize.height);
                _this.transform.maxScale = _this.referenceImageWidth / _this.wrapperSize.width;
                _this.scale100Percent = _this.wrapperSize.width * devicePixelRatio / _this.referenceImageWidth;

                if (_this.maxZoom < Infinity) {
                  _this.transform.maxScale = _this.scale100Percent * _this.maxZoom / 100;
                }

                if (_this.minZoom > 0) {
                  _this.transform.minScale = _this.scale100Percent * _this.minZoom / 100;
                } // set center


                if (!_this.$xp.history.historyParams.transform) {
                  _context.next = 16;
                  break;
                }

                transform = Object.assign({}, _this.$xp.history.historyParams.transform);

                _this.setScale(transform.scale);

                _context.next = 13;
                return _this.$nextTick();

              case 13:
                _this.setTransform(transform.x, transform.y);

                _context.next = 20;
                break;

              case 16:
                _this.startZoom ? _this.setScale(_this.startZoom / 100 * _this.scale100Percent) : _this.setScale(_this.scale100Percent);
                _context.next = 19;
                return _this.$nextTick();

              case 19:
                if (_this.startCenter.x !== null && _this.startCenter.y != null && (Math.abs(_this.startCenter.x) > 0 || Math.abs(_this.startCenter.y) > 0)) {
                  // console.log('startCenter set', this.startCenter)
                  _this.setCenter(_this.startCenter.x, _this.startCenter.y);
                } else {
                  _this.setCenter(0, 0); // this.setTransform(this.transform.x, this.transform.y)

                }

              case 20:
                if (_this.geoData) {
                  _this.initLocationSystem(_this.geoData); // set center on pseudo location


                  pseudoCoords = _this.getPseudoCoords();

                  if (pseudoCoords) {
                    console.log(pseudoCoords);
                    x = _this.width * (Math.abs(pseudoCoords.easting - _this.geoData.topLeft.easting) / Math.abs(_this.geoData.bottomRight.easting - _this.geoData.topLeft.easting));
                    y = _this.height * (Math.abs(pseudoCoords.northing - _this.geoData.topLeft.northing) / Math.abs(_this.geoData.bottomRight.northing - _this.geoData.topLeft.northing));
                    setTimeout(function () {
                      _this.setCenter(x, y);
                    }, 300);
                  }
                  /*
                  let corners = [
                    this.geoData.topLeft,
                    this.geoData.bottomRight,
                    // { easting: 107, northing: 84, accuracy: 5, zone: 32, hemisphere: 'N' }
                    { easting: 87, northing: 16, accuracy: 5, zone: 32, hemisphere: 'N' }
                  ]
                   this.showLocationPathCorners(corners)
                  setInterval(() => { this.showLocationPathCorners(corners) }, 30000)
                  */
                  // setInterval(() => { this.showLocationPathCircle(this.coordsCenter, (this.coordsBoundries.rotatedBottomRight.northing - this.coordsBoundries.rotatedTopLeft.northing) / 3) }, 300)
                  // console.log('coordsBoundries:', this.coordsBoundries)
                  // console.log('geo width:', Math.abs(this.coordsBoundries.rotatedBottomRight.easting - this.coordsBoundries.rotatedTopLeft.easting))
                  // console.log('geo height:', Math.abs(this.coordsBoundries.rotatedBottomRight.northing - this.coordsBoundries.rotatedTopLeft.northing))
                  // console.log('geo rotated width:', Math.abs(this.coordsBoundries.bottomRight.easting - this.coordsBoundries.topLeft.easting))
                  // console.log('geo rotated height:', Math.abs(this.coordsBoundries.bottomRight.northing - this.coordsBoundries.topLeft.northing))

                }

                _this.lastTouchData = _this.touchData = {};
                _context.next = 24;
                return _this.$nextTick();

              case 24:
                setTimeout(function () {
                  _this.isInitialized = true;
                }, 300);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onStandPointIndicatorPositionChanged: function onStandPointIndicatorPositionChanged(_ref) {
      var topPercentage = _ref.topPercentage,
          leftPercentage = _ref.leftPercentage;

      // console.log(`--- this.setCenter(${this.width * leftPercentage / 100}, ${this.height * topPercentage / 100})`)
      if (!this.isStandPointIndicatorInViewport() && !this.isInteracting && !this.isAutoScrolling) {
        this.setCenter(this.width * leftPercentage / 100, this.height * topPercentage / 100);
      }
    },
    getPseudoCoords: function getPseudoCoords() {
      if (this.geoData && typeof this.geoData.system === 'string' && this.geoData.system.toLowerCase() === 'pseudo') {
        var pseudoEngine = this.$xp.positioning.getEngine('Pseudo');
        return pseudoEngine.getLastPosition();
      }

      return null;
    },
    changeScale: function changeScale(dScale, center) {
      this.setScale(this.transform.scale + dScale, center);
    },
    setScale: function setScale(scale, center) {
      scale = Math.max(Math.min(scale, this.transform.maxScale), this.transform.minScale);
      var dX;
      var dY;

      if (center) {
        var boundingRect = this.mapElement.getBoundingClientRect();
        var cX = (center.x - boundingRect.left) / boundingRect.width * this.mapSize.width;
        var cY = (center.y - boundingRect.top) / boundingRect.height * this.mapSize.height;
        dX = (this.mapSize.width / 2 - cX) * (scale - this.transform.scale);
        dY = (this.mapSize.height / 2 - cY) * (scale - this.transform.scale);
      }

      var oldScale = this.transform.scale;
      this.transform.scale = scale;
      this.transform.maxX = -(this.mapSize.width * (1 - scale)) / 2 + Math.max(0, (this.wrapperSize.width - this.mapSize.width * scale) / 2);
      this.transform.maxY = -(this.mapSize.height * (1 - scale)) / 2 + Math.max(0, (this.wrapperSize.height - this.mapSize.height * scale) / 2);
      this.transform.minX = this.transform.maxX - Math.max(0, this.mapSize.width * scale - this.wrapperSize.width);
      this.transform.minY = this.transform.maxY - Math.max(0, this.mapSize.height * scale - this.wrapperSize.height);

      if (center) {
        this.changeTransform(dX, dY);
      }

      this.$emit('scaleChanged', this.transform.scale / this.scale100Percent * 100, oldScale / this.scale100Percent * 100);
    },
    changeTransform: function changeTransform(dX, dY) {
      this.setTransform(dX ? this.transform.x + dX : null, dY ? this.transform.y + dY : null);
    },
    setTransform: function setTransform(x, y) {
      if (x !== null) {
        this.transform.x = Math.max(Math.min(x, this.transform.maxX), this.transform.minX); // this.transform.x = x
      }

      if (y !== null) {
        this.transform.y = Math.max(Math.min(y, this.transform.maxY), this.transform.minY); // this.transform.y = y
      }
    },
    canPanX: function canPanX() {
      return this.transform.x < this.transform.maxX && Math.abs(this.transform.x - this.transform.maxX) >= 1 || this.transform.x > this.transform.minX && Math.abs(this.transform.x - this.transform.minX) >= 1;
    },
    canPanY: function canPanY() {
      return this.transform.y < this.transform.maxY && Math.abs(this.transform.y - this.transform.maxY) >= 1 || this.transform.y > this.transform.minY && Math.abs(this.transform.y - this.transform.minY) >= 1;
    },
    canPan: function canPan() {
      return this.canPanX() || this.canPanY();
    },
    onTouchStart: function onTouchStart(e) {
      this.showHints = false;
      if (this.isInteracting) return;
      this.isInteracting = true;
      this.hasMoved = false;
      this.lastTouchData = this.touchData = this.getTouchDataFromEvent(e);

      if (this.allowZoom) {
        this.checkForDoubleTap(e);
      }

      this.touchStartTime = new Date().getTime();
    },
    onTouchMove: function onTouchMove(e) {
      if (this.isInteracting === false) return;

      if (!this.$xp.screen.isBrowserNavBarVisible) {
        e.preventDefault();
      }

      this.touchData = this.getTouchDataFromEvent(e, this.lastTouchData);
      var dX = this.touchData.x - this.lastTouchData.x;
      var dY = this.touchData.y - this.lastTouchData.y;

      if (Math.abs(dX) >= 3 || Math.abs(dY) >= 3) {
        this.hasMoved = true;
      }

      this.changeTransform(dX, dY);

      if (this.allowZoom && this.touchData.pinchLength && this.lastTouchData.pinchLength) {
        var ratio = this.touchData.pinchLength / this.lastTouchData.pinchLength;
        var scale = this.transform.scale * ratio;
        this.setScale(scale, this.touchData);
      }

      this.lastTouchData = this.touchData;
    },
    onTouchEnd: function onTouchEnd(e) {
      var _this2 = this;

      this.isInteracting = false;
      var time = new Date().getTime();

      if (this.hasMoved || time - this.touchStartTime > 800) {
        e.stopPropagation(); // Workaround: stopPropagation() ist notwendig, um click-Events auf der Imagemap zu verhindern,
        // wenn der PageContainer das event nicht bekommt, werden aber die Navigationsleisten nicht wieder ausgeblendet
        // Deshalb wird das Event explizit an den .c-map gesendet.

        this.$el.dispatchEvent(new Event(e.type, e));
      } // console.log('touchData: ', this.lastTouchData)


      var vel = Math.sqrt(Math.pow(this.lastTouchData.vX, 2) + Math.pow(this.lastTouchData.vY, 2));

      if (vel > 10) {
        this.lastTouchData.autoTransformX = this.transform.x + 0.8 * this.lastTouchData.vX;
        this.lastTouchData.autoTransformY = this.transform.y + 0.8 * this.lastTouchData.vY;
        requestAnimationFrame(function () {
          _this2.autoScroll();
        });
      } else {
        this.saveTransformStateInHistory(this.transform, this.pageId);
      }
    },
    checkForDoubleTap: function checkForDoubleTap(e) {
      if (this.$xp.device.platform !== 'browser') {
        if (e.touches.length === 1) {
          tapCounter++;
          singleClickTimer = setTimeout(function () {
            tapCounter = 0;
          }, 200);

          if (tapCounter === 2) {
            clearTimeout(singleClickTimer);
            tapCounter = 0;
            this.onDoubleTap(e);
          }
        }
      }
    },
    onDoubleTap: function onDoubleTap(e) {
      var touch = this.getTouchDataFromEvent(e);
      var scale = this.transform.scale * this.doubleTapZoomRatio;
      this.setScale(scale, touch);
    },
    autoScroll: function autoScroll() {
      var _this3 = this;

      if (this.lastTouchData.autoTransformX) {
        this.isAutoScrolling = true;
        var elapsed = Date.now() - this.lastTouchData.time;
        var exp = -0.8 * Math.exp(-elapsed / 325);
        var dX = this.lastTouchData.vX * exp;
        var dY = this.lastTouchData.vY * exp; // console.log('autoScroll() dX=', dX, 'dY=', dY, 'elapsed=', elapsed, 'exp=', exp)

        this.setTransform(this.lastTouchData.autoTransformX + dX, this.lastTouchData.autoTransformY + dY);

        if (Math.abs(dX) + Math.abs(dY) > 1) {
          requestAnimationFrame(function () {
            _this3.autoScroll();
          });
        } else {
          this.isAutoScrolling = false;
          this.lastTouchData.autoTransformX = null;
          this.saveTransformStateInHistory(this.transform, this.pageId);
        }
      }
    },
    onMouseWheel: function onMouseWheel(e) {
      this.isInteracting = true;
      var touch = this.getTouchDataFromEvent(e); // console.log('onMouseWheel x=', touch.x)

      var ratio = e.deltaY > 0 ? 0.9 : 1.1;
      var scale = this.transform.scale * ratio;
      this.setScale(scale, touch);
      this.removeIsInteractingAfterWheel();
    },
    removeIsInteractingAfterWheel: function removeIsInteractingAfterWheel() {
      this.isInteracting = false;
    },
    setCenter: function setCenter(x, y) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var boundingRect, x1, y1, cX, cY;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("setCenter(".concat(x, ", ").concat(y, ")"));
                boundingRect = _this4.mapElement.getBoundingClientRect();
                x1 = !x ? 0 : x / devicePixelRatio * (boundingRect.width / _this4.mapSize.width);
                y1 = !y ? 0 : y / devicePixelRatio * (boundingRect.height / _this4.mapSize.height);
                console.log("x1= ".concat(x1, ", y1= ").concat(y1), {
                  x1: x1,
                  y1: y1
                }); // let cX = (this.wrapperSize.width / 2) - x * boundingRect.width / (this.mapSize.width * devicePixelRatio) - boundingRect.left
                // let cY = (this.wrapperSize.height / 2) - y * boundingRect.height / (this.mapSize.height * devicePixelRatio) - boundingRect.top
                // console.log(`boundingRect `, { left: boundingRect.left, top: boundingRect.top, width: boundingRect.width, height: boundingRect.height })
                // console.log(`wrapperSize `, { width: this.wrapperSize.width, height: this.wrapperSize.height })

                cX = _this4.wrapperSize.width / 2 - boundingRect.left - x1;
                cY = _this4.wrapperSize.height / 2 - boundingRect.top - y1; // console.log('setCenter(', x, ', ', y, ') => cX=', cX, ', cY=', cY, ', boundingRect=', boundingRect, ', mapSize=', this.mapSize)
                // console.log({ x, y, cX, cY })

                _this4.changeTransform(cX, cY); // await this.$nextTick()
                // boundingRect = this.mapElement.getBoundingClientRect()
                // console.log(`boundingRect `, { left: boundingRect.left, top: boundingRect.top, width: boundingRect.width, height: boundingRect.height })
                // console.log({ transformX: this.transform.x, transformY: this.transform.y })


              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getTouchDataFromEvent: function getTouchDataFromEvent(event, lastData) {
      var data = {
        x: 0,
        y: 0,
        vX: 0,
        vY: 0,
        pinchLength: null,
        time: Date.now()
      };

      if (event.type.match(/^(mouse|wheel)/)) {
        data.x = event.clientX;
        data.y = event.clientY;
      } else {
        if (event.touches.length === 1) {
          data.x = event.touches[0].clientX;
          data.y = event.touches[0].clientY;
        } else if (event.touches.length >= 2) {
          var finger1 = event.touches[0];
          var finger2 = event.touches[1];
          data.x = event.touches[0].clientX; // (finger1.clientX + finger2.clientX) / 2

          data.y = event.touches[0].clientY; // (finger1.clientY + finger2.clientY) / 2

          data.pinchLength = Math.sqrt(Math.pow(finger2.clientX - finger1.clientX, 2) + Math.pow(finger2.clientY - finger1.clientY, 2));
        }
      }

      if (lastData) {
        var d = data.time - lastData.time;
        var f = 300;
        var vX = f * (data.x - lastData.x) / (1 + d);
        var vY = f * (data.y - lastData.y) / (1 + d);
        data.vX = 0.8 * vX + 0.2 * lastData.vX;
        data.vY = 0.8 * vY + 0.2 * lastData.vY;

        if (data.pinchLength && lastData.pinchLength) {
          data.pinchLength = 0.8 * data.pinchLength + 0.2 * lastData.pinchLength;
        }
      }

      return data;
    },
    reInit: function reInit() {
      var _this5 = this;

      console.log('reInit panzoomMap');

      if (this.wrapperSize.width === 0) {
        // not initialized yet
        this.wrapperSize = this.mapElement.parentElement.getBoundingClientRect();

        if (this.wrapperSize.width > 0) {
          this.init();
        } else {
          setTimeout(function () {
            _this5.reInit();
          }, 200);
        }
      }
    },
    // showLocationPathCircle (center, radius) {
    //   this.locationPathAngle += 3
    //   let angle = this.locationPathAngle * Math.PI / 180
    //   let coords = {
    //     easting: center.easting + Math.cos(angle) * radius,
    //     northing: center.northing + Math.sin(angle) * radius,
    //     accuracy: 4
    //   }
    //   if (!isNaN(coords.easting) && !isNaN(coords.northing)) {
    //     this.showStandPoint(coords)
    //   }
    // },
    showLocationPathCorners: function showLocationPathCorners(corners) {
      this.locationPathAngle = (this.locationPathAngle + 1) % corners.length; // console.log('showLocationPathCorner(', this.locationPathAngle, '): ', corners[this.locationPathAngle])

      var corner = corners[this.locationPathAngle];
      this.showStandPoint(corner);
    },
    saveTransformStateInHistory: function saveTransformStateInHistory(newTransform, pageId) {
      console.log('saveTransformStateInHistory(', newTransform, ') for pageId=', pageId);
      this.$xp.history.setHistoryParam(pageId, 'transform', newTransform);
    }
  },
  watch: {
    '$xp.screen.orientation': {
      handler: function handler() {
        var _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
          return regenerator.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this6.$nextTick();

                case 2:
                  setTimeout(function () {
                    _this6.wrapperSize = _this6.getWrapperSize();

                    _this6.init();
                  }, 1000);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    },
    '$xp.screen.isBrowserNavBarVisible': {
      handler: function handler() {
        var _this7 = this;

        return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
          return regenerator.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this7.$nextTick();

                case 2:
                  setTimeout(function () {
                    _this7.wrapperSize = _this7.getWrapperSize();

                    _this7.init();
                  }, 1000);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-map" }, [
    _c(
      "div",
      {
        staticClass: "c-map__wrapper",
        on: {
          mousewheel: _vm.onMouseWheel,
          wheel: _vm.onMouseWheel,
          touchstart: function($event) {
            $event.preventDefault();
            return _vm.onTouchStart($event)
          },
          mousedown: function($event) {
            $event.preventDefault();
            return _vm.onTouchStart($event)
          },
          touchmove: _vm.onTouchMove,
          mousemove: _vm.onTouchMove,
          "!touchend": function($event) {
            $event.preventDefault();
            return _vm.onTouchEnd($event)
          },
          "!mouseup": function($event) {
            $event.preventDefault();
            return _vm.onTouchEnd($event)
          }
        }
      },
      [
        _c(
          "div",
          {
            class: {
              "js-map": true,
              "c-map__content": true,
              "c-map__content--smooth-transform":
                !_vm.isInteracting && !_vm.isAutoScrolling && _vm.isInitialized
            },
            style:
              "transform: " +
              _vm.transformMatrix +
              "; width: " +
              _vm.width / _vm.devicePixelRatio +
              "px; height: " +
              _vm.height / _vm.devicePixelRatio +
              "px"
          },
          [
            _vm._t("default"),
            _vm._v(" "),
            _c("span", { staticClass: "js-stand-point c-stand-point" }, [
              _c("span", {
                staticClass: "c-stand-point__blue-point",
                style:
                  "transform: translate(-50%, -50%) scale(" +
                  1 / _vm.transform.scale +
                  ")"
              })
            ])
          ],
          2
        ),
        _vm._v(" "),
        _vm.showHints && _vm.minZoom !== _vm.maxZoom
          ? _c("img", {
              class: {
                "c-map__zoom-hint": true,
                "c-map__hint": true,
                animated: _vm.isInitialized,
                fadeOut: _vm.isInitialized
              },
              attrs: {
                "aria-hidden": "true",
                src:
                  "data:image/svg+xml;base64,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"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showHints && _vm.minZoom === _vm.maxZoom && _vm.canPanX()
          ? _c("img", {
              class: {
                "c-map__pan-hint": true,
                "c-map__hint": true,
                animated: _vm.isInitialized,
                fadeOut: _vm.isInitialized
              },
              attrs: {
                "aria-hidden": "true",
                src:
                  "data:image/svg+xml;base64,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"
              }
            })
          : _vm._e()
      ]
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

/**
 * Helpers.
 */
var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function ms(val, options) {
  options = options || {};

  var type = _typeof(val);

  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }

  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */


function parse(str) {
  str = String(str);

  if (str.length > 100) {
    return;
  }

  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);

  if (!match) {
    return;
  }

  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();

  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;

    case 'weeks':
    case 'week':
    case 'w':
      return n * w;

    case 'days':
    case 'day':
    case 'd':
      return n * d;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;

    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;

    default:
      return undefined;
  }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtShort(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }

  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }

  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }

  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }

  return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtLong(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }

  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }

  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }

  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }

  return ms + ' ms';
}
/**
 * Pluralization helper.
 */


function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = ms;
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // Disabled?
      if (!debug.enabled) {
        return;
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
    newDebug.log = this.log;
    return newDebug;
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @return {String} namespaces
  * @api public
  */


  function disable() {
    var namespaces = [].concat(_toConsumableArray(createDebug.names.map(toNamespace)), _toConsumableArray(createDebug.skips.map(toNamespace).map(function (namespace) {
      return '-' + namespace;
    }))).join(',');
    createDebug.enable('');
    return namespaces;
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Convert regexp to namespace
  *
  * @param {RegExp} regxep
  * @return {String} namespace
  * @api private
  */


  function toNamespace(regexp) {
    return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

var common = setup;

var browser = createCommonjsModule(function (module, exports) {
  /* eslint-env browser */

  /**
   * This is the web browser implementation of `debug()`.
   */
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = localstorage();
  /**
   * Colors.
   */

  exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
  /**
   * Currently only WebKit-based Web Inspectors, Firefox >= v31,
   * and the Firebug extension (any Firefox version) are known
   * to support "%c" CSS customizations.
   *
   * TODO: add a `localStorage` variable to explicitly enable/disable colors
   */
  // eslint-disable-next-line complexity

  function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
      return true;
    } // Internet Explorer and Edge do not support colors.


    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
      return false;
    } // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  /**
   * Colorize log arguments if enabled.
   *
   * @api public
   */


  function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

    if (!this.useColors) {
      return;
    }

    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into

    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function (match) {
      if (match === '%%') {
        return;
      }

      index++;

      if (match === '%c') {
        // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
      }
    });
    args.splice(lastC, 0, c);
  }
  /**
   * Invokes `console.log()` when available.
   * No-op when `console.log` is not a "function".
   *
   * @api public
   */


  function log() {
    var _console;

    // This hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
  }
  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */


  function save(namespaces) {
    try {
      if (namespaces) {
        exports.storage.setItem('debug', namespaces);
      } else {
        exports.storage.removeItem('debug');
      }
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    }
  }
  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */


  function load() {
    var r;

    try {
      r = exports.storage.getItem('debug');
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    } // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


    if (!r && typeof process !== 'undefined' && 'env' in process) {
      r = process.env.DEBUG;
    }

    return r;
  }
  /**
   * Localstorage attempts to return the localstorage.
   *
   * This is necessary because safari throws
   * when a user disables cookies/localstorage
   * and you attempt to access it.
   *
   * @return {LocalStorage}
   * @api private
   */


  function localstorage() {
    try {
      // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
      // The Browser also has localStorage in the global context.
      return localStorage;
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    }
  }

  module.exports = common(exports);
  var formatters = module.exports.formatters;
  /**
   * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
   */

  formatters.j = function (v) {
    try {
      return JSON.stringify(v);
    } catch (error) {
      return '[UnexpectedJSONParseError]: ' + error.message;
    }
  };
});
var browser_1 = browser.log;
var browser_2 = browser.formatArgs;
var browser_3 = browser.save;
var browser_4 = browser.load;
var browser_5 = browser.useColors;
var browser_6 = browser.storage;
var browser_7 = browser.colors;

var isBuffer = function isBuffer(arg) {
  return arg instanceof Buffer;
};

var inherits_browser = createCommonjsModule(function (module) {
  if (typeof Object.create === 'function') {
    // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;

      var TempCtor = function TempCtor() {};

      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
});

var inherits = createCommonjsModule(function (module) {
  try {
    var util$1 = util;
    if (typeof util$1.inherits !== 'function') throw '';
    module.exports = util$1.inherits;
  } catch (e) {
    module.exports = inherits_browser;
  }
});

var util = createCommonjsModule(function (module, exports) {
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};

    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }

    return descriptors;
  };

  var formatRegExp = /%[sdj%]/g;

  exports.format = function (f) {
    if (!isString(f)) {
      var objects = [];

      for (var i = 0; i < arguments.length; i++) {
        objects.push(inspect(arguments[i]));
      }

      return objects.join(' ');
    }

    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') return '%';
      if (i >= len) return x;

      switch (x) {
        case '%s':
          return String(args[i++]);

        case '%d':
          return Number(args[i++]);

        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }

        default:
          return x;
      }
    });

    for (var x = args[i]; i < len; x = args[++i]) {
      if (isNull(x) || !isObject(x)) {
        str += ' ' + x;
      } else {
        str += ' ' + inspect(x);
      }
    }

    return str;
  }; // Mark that a method should not be used.
  // Returns a modified function which warns once by default.
  // If --no-deprecation is set, then it is a no-op.


  exports.deprecate = function (fn, msg) {
    if (typeof process !== 'undefined' && process.noDeprecation === true) {
      return fn;
    } // Allow for deprecating things in the process of starting up.


    if (typeof process === 'undefined') {
      return function () {
        return exports.deprecate(fn, msg).apply(this, arguments);
      };
    }

    var warned = false;

    function deprecated() {
      if (!warned) {
        if (process.throwDeprecation) {
          throw new Error(msg);
        } else if (process.traceDeprecation) {
          console.trace(msg);
        } else {
          console.error(msg);
        }

        warned = true;
      }

      return fn.apply(this, arguments);
    }

    return deprecated;
  };

  var debugs = {};
  var debugEnviron;

  exports.debuglog = function (set) {
    if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
    set = set.toUpperCase();

    if (!debugs[set]) {
      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
        var pid = process.pid;

        debugs[set] = function () {
          var msg = exports.format.apply(exports, arguments);
          console.error('%s %d: %s', set, pid, msg);
        };
      } else {
        debugs[set] = function () {};
      }
    }

    return debugs[set];
  };
  /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */

  /* legacy: obj, showHidden, depth, colors*/


  function inspect(obj, opts) {
    // default options
    var ctx = {
      seen: [],
      stylize: stylizeNoColor
    }; // legacy...

    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];

    if (isBoolean(opts)) {
      // legacy...
      ctx.showHidden = opts;
    } else if (opts) {
      // got an "options" object
      exports._extend(ctx, opts);
    } // set default options


    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
  }

  exports.inspect = inspect; // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics

  inspect.colors = {
    'bold': [1, 22],
    'italic': [3, 23],
    'underline': [4, 24],
    'inverse': [7, 27],
    'white': [37, 39],
    'grey': [90, 39],
    'black': [30, 39],
    'blue': [34, 39],
    'cyan': [36, 39],
    'green': [32, 39],
    'magenta': [35, 39],
    'red': [31, 39],
    'yellow': [33, 39]
  }; // Don't use 'blue' not visible on cmd.exe

  inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
  };

  function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];

    if (style) {
      return "\x1B[" + inspect.colors[style][0] + 'm' + str + "\x1B[" + inspect.colors[style][1] + 'm';
    } else {
      return str;
    }
  }

  function stylizeNoColor(str, styleType) {
    return str;
  }

  function arrayToHash(array) {
    var hash = {};
    array.forEach(function (val, idx) {
      hash[val] = true;
    });
    return hash;
  }

  function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);

      if (!isString(ret)) {
        ret = formatValue(ctx, ret, recurseTimes);
      }

      return ret;
    } // Primitive types cannot have properties


    var primitive = formatPrimitive(ctx, value);

    if (primitive) {
      return primitive;
    } // Look up the keys of the object.


    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);

    if (ctx.showHidden) {
      keys = Object.getOwnPropertyNames(value);
    } // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx


    if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
      return formatError(value);
    } // Some type of object without properties can be shortcutted.


    if (keys.length === 0) {
      if (isFunction(value)) {
        var name = value.name ? ': ' + value.name : '';
        return ctx.stylize('[Function' + name + ']', 'special');
      }

      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      }

      if (isDate(value)) {
        return ctx.stylize(Date.prototype.toString.call(value), 'date');
      }

      if (isError(value)) {
        return formatError(value);
      }
    }

    var base = '',
        array = false,
        braces = ['{', '}']; // Make Array say that they are Array

    if (isArray(value)) {
      array = true;
      braces = ['[', ']'];
    } // Make functions say that they are functions


    if (isFunction(value)) {
      var n = value.name ? ': ' + value.name : '';
      base = ' [Function' + n + ']';
    } // Make RegExps say that they are RegExps


    if (isRegExp(value)) {
      base = ' ' + RegExp.prototype.toString.call(value);
    } // Make dates with properties first say the date


    if (isDate(value)) {
      base = ' ' + Date.prototype.toUTCString.call(value);
    } // Make error with message first say the error


    if (isError(value)) {
      base = ' ' + formatError(value);
    }

    if (keys.length === 0 && (!array || value.length == 0)) {
      return braces[0] + base + braces[1];
    }

    if (recurseTimes < 0) {
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      } else {
        return ctx.stylize('[Object]', 'special');
      }
    }

    ctx.seen.push(value);
    var output;

    if (array) {
      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    } else {
      output = keys.map(function (key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
      });
    }

    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
  }

  function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');

    if (isString(value)) {
      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
      return ctx.stylize(simple, 'string');
    }

    if (isNumber(value)) return ctx.stylize('' + value, 'number');
    if (isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.

    if (isNull(value)) return ctx.stylize('null', 'null');
  }

  function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
  }

  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];

    for (var i = 0, l = value.length; i < l; ++i) {
      if (hasOwnProperty(value, String(i))) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
      } else {
        output.push('');
      }
    }

    keys.forEach(function (key) {
      if (!key.match(/^\d+$/)) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
      }
    });
    return output;
  }

  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
      value: value[key]
    };

    if (desc.get) {
      if (desc.set) {
        str = ctx.stylize('[Getter/Setter]', 'special');
      } else {
        str = ctx.stylize('[Getter]', 'special');
      }
    } else {
      if (desc.set) {
        str = ctx.stylize('[Setter]', 'special');
      }
    }

    if (!hasOwnProperty(visibleKeys, key)) {
      name = '[' + key + ']';
    }

    if (!str) {
      if (ctx.seen.indexOf(desc.value) < 0) {
        if (isNull(recurseTimes)) {
          str = formatValue(ctx, desc.value, null);
        } else {
          str = formatValue(ctx, desc.value, recurseTimes - 1);
        }

        if (str.indexOf('\n') > -1) {
          if (array) {
            str = str.split('\n').map(function (line) {
              return '  ' + line;
            }).join('\n').substr(2);
          } else {
            str = '\n' + str.split('\n').map(function (line) {
              return '   ' + line;
            }).join('\n');
          }
        }
      } else {
        str = ctx.stylize('[Circular]', 'special');
      }
    }

    if (isUndefined(name)) {
      if (array && key.match(/^\d+$/)) {
        return str;
      }

      name = JSON.stringify('' + key);

      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
        name = name.substr(1, name.length - 2);
        name = ctx.stylize(name, 'name');
      } else {
        name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
        name = ctx.stylize(name, 'string');
      }
    }

    return name + ': ' + str;
  }

  function reduceToSingleString(output, base, braces) {
    var length = output.reduce(function (prev, cur) {
      if (cur.indexOf('\n') >= 0) ;
      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);

    if (length > 60) {
      return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    }

    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
  } // NOTE: These type checking functions intentionally don't use `instanceof`
  // because it is fragile and can be easily faked with `Object.create()`.


  function isArray(ar) {
    return Array.isArray(ar);
  }

  exports.isArray = isArray;

  function isBoolean(arg) {
    return typeof arg === 'boolean';
  }

  exports.isBoolean = isBoolean;

  function isNull(arg) {
    return arg === null;
  }

  exports.isNull = isNull;

  function isNullOrUndefined(arg) {
    return arg == null;
  }

  exports.isNullOrUndefined = isNullOrUndefined;

  function isNumber(arg) {
    return typeof arg === 'number';
  }

  exports.isNumber = isNumber;

  function isString(arg) {
    return typeof arg === 'string';
  }

  exports.isString = isString;

  function isSymbol(arg) {
    return _typeof(arg) === 'symbol';
  }

  exports.isSymbol = isSymbol;

  function isUndefined(arg) {
    return arg === void 0;
  }

  exports.isUndefined = isUndefined;

  function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
  }

  exports.isRegExp = isRegExp;

  function isObject(arg) {
    return _typeof(arg) === 'object' && arg !== null;
  }

  exports.isObject = isObject;

  function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
  }

  exports.isDate = isDate;

  function isError(e) {
    return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
  }

  exports.isError = isError;

  function isFunction(arg) {
    return typeof arg === 'function';
  }

  exports.isFunction = isFunction;

  function isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || _typeof(arg) === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
  }

  exports.isPrimitive = isPrimitive;
  exports.isBuffer = isBuffer;

  function objectToString(o) {
    return Object.prototype.toString.call(o);
  }

  function pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
  }

  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; // 26 Feb 16:19:34

  function timestamp() {
    var d = new Date();
    var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
    return [d.getDate(), months[d.getMonth()], time].join(' ');
  } // log is just a thin wrapper to console.log that prepends a timestamp


  exports.log = function () {
    console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
  };
  /**
   * Inherit the prototype methods from one constructor into another.
   *
   * The Function.prototype.inherits from lang.js rewritten as a standalone
   * function (not on Function.prototype). NOTE: If this file is to be loaded
   * during bootstrapping this function needs to be rewritten using some native
   * functions as prototype setup using normal JavaScript does not work as
   * expected during bootstrapping (see mirror.js in r114903).
   *
   * @param {function} ctor Constructor function which needs to inherit the
   *     prototype.
   * @param {function} superCtor Constructor function to inherit prototype from.
   */


  exports.inherits = inherits;

  exports._extend = function (origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;

    while (i--) {
      origin[keys[i]] = add[keys[i]];
    }

    return origin;
  };

  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

  exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');

    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
      var fn = original[kCustomPromisifiedSymbol];

      if (typeof fn !== 'function') {
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      }

      Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
      });
      return fn;
    }

    function fn() {
      var promiseResolve, promiseReject;
      var promise = new Promise(function (resolve, reject) {
        promiseResolve = resolve;
        promiseReject = reject;
      });
      var args = [];

      for (var i = 0; i < arguments.length; i++) {
        args.push(arguments[i]);
      }

      args.push(function (err, value) {
        if (err) {
          promiseReject(err);
        } else {
          promiseResolve(value);
        }
      });

      try {
        original.apply(this, args);
      } catch (err) {
        promiseReject(err);
      }

      return promise;
    }

    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn,
      enumerable: false,
      writable: false,
      configurable: true
    });
    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
  };

  exports.promisify.custom = kCustomPromisifiedSymbol;

  function callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
      var newReason = new Error('Promise was rejected with a falsy value');
      newReason.reason = reason;
      reason = newReason;
    }

    return cb(reason);
  }

  function callbackify(original) {
    if (typeof original !== 'function') {
      throw new TypeError('The "original" argument must be of type Function');
    } // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.


    function callbackified() {
      var args = [];

      for (var i = 0; i < arguments.length; i++) {
        args.push(arguments[i]);
      }

      var maybeCb = args.pop();

      if (typeof maybeCb !== 'function') {
        throw new TypeError('The last argument must be of type Function');
      }

      var self = this;

      var cb = function cb() {
        return maybeCb.apply(self, arguments);
      }; // In true node style we process the callback on `nextTick` with all the
      // implications (stack, `uncaughtException`, `async_hooks`)


      original.apply(this, args).then(function (ret) {
        process.nextTick(cb, null, ret);
      }, function (rej) {
        process.nextTick(callbackifyOnRejected, rej, cb);
      });
    }

    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
    return callbackified;
  }

  exports.callbackify = callbackify;
});
var util_1 = util.format;
var util_2 = util.deprecate;
var util_3 = util.debuglog;
var util_4 = util.inspect;
var util_5 = util.isArray;
var util_6 = util.isBoolean;
var util_7 = util.isNull;
var util_8 = util.isNullOrUndefined;
var util_9 = util.isNumber;
var util_10 = util.isString;
var util_11 = util.isSymbol;
var util_12 = util.isUndefined;
var util_13 = util.isRegExp;
var util_14 = util.isObject;
var util_15 = util.isDate;
var util_16 = util.isError;
var util_17 = util.isFunction;
var util_18 = util.isPrimitive;
var util_19 = util.isBuffer;
var util_20 = util.log;
var util_21 = util.inherits;
var util_22 = util._extend;
var util_23 = util.promisify;
var util_24 = util.callbackify;

var hasFlag = function hasFlag(flag, argv) {
  argv = argv || process.argv;
  var prefix = flag.startsWith('-') ? '' : flag.length === 1 ? '-' : '--';
  var pos = argv.indexOf(prefix + flag);
  var terminatorPos = argv.indexOf('--');
  return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

var _process = process,
    env = _process.env;
var forceColor;

if (hasFlag('no-color') || hasFlag('no-colors') || hasFlag('color=false') || hasFlag('color=never')) {
  forceColor = 0;
} else if (hasFlag('color') || hasFlag('colors') || hasFlag('color=true') || hasFlag('color=always')) {
  forceColor = 1;
}

if ('FORCE_COLOR' in env) {
  if (env.FORCE_COLOR === true || env.FORCE_COLOR === 'true') {
    forceColor = 1;
  } else if (env.FORCE_COLOR === false || env.FORCE_COLOR === 'false') {
    forceColor = 0;
  } else {
    forceColor = env.FORCE_COLOR.length === 0 ? 1 : Math.min(parseInt(env.FORCE_COLOR, 10), 3);
  }
}

function translateLevel(level) {
  if (level === 0) {
    return false;
  }

  return {
    level: level,
    hasBasic: true,
    has256: level >= 2,
    has16m: level >= 3
  };
}

function supportsColor(stream) {
  if (forceColor === 0) {
    return 0;
  }

  if (hasFlag('color=16m') || hasFlag('color=full') || hasFlag('color=truecolor')) {
    return 3;
  }

  if (hasFlag('color=256')) {
    return 2;
  }

  if (stream && !stream.isTTY && forceColor === undefined) {
    return 0;
  }

  var min = forceColor || 0;

  if (env.TERM === 'dumb') {
    return min;
  }

  if (process.platform === 'win32') {
    // Node.js 7.5.0 is the first version of Node.js to include a patch to
    // libuv that enables 256 color output on Windows. Anything earlier and it
    // won't work. However, here we target Node.js 8 at minimum as it is an LTS
    // release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
    // release that supports 256 colors. Windows 10 build 14931 is the first release
    // that supports 16m/TrueColor.
    var osRelease = os.release().split('.');

    if (Number(process.versions.node.split('.')[0]) >= 8 && Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
      return Number(osRelease[2]) >= 14931 ? 3 : 2;
    }

    return 1;
  }

  if ('CI' in env) {
    if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(function (sign) {
      return sign in env;
    }) || env.CI_NAME === 'codeship') {
      return 1;
    }

    return min;
  }

  if ('TEAMCITY_VERSION' in env) {
    return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
  }

  if (env.COLORTERM === 'truecolor') {
    return 3;
  }

  if ('TERM_PROGRAM' in env) {
    var version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

    switch (env.TERM_PROGRAM) {
      case 'iTerm.app':
        return version >= 3 ? 3 : 2;

      case 'Apple_Terminal':
        return 2;
      // No default
    }
  }

  if (/-256(color)?$/i.test(env.TERM)) {
    return 2;
  }

  if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
    return 1;
  }

  if ('COLORTERM' in env) {
    return 1;
  }

  return min;
}

function getSupportLevel(stream) {
  var level = supportsColor(stream);
  return translateLevel(level);
}

var supportsColor_1 = {
  supportsColor: getSupportLevel,
  stdout: getSupportLevel(process.stdout),
  stderr: getSupportLevel(process.stderr)
};

var node = createCommonjsModule(function (module, exports) {
  /**
   * Module dependencies.
   */

  /**
   * This is the Node.js implementation of `debug()`.
   */
  exports.init = init;
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  /**
   * Colors.
   */

  exports.colors = [6, 2, 3, 4, 5, 1];

  try {
    // Optional dependency (as in, doesn't need to be installed, NOT like optionalDependencies in package.json)
    // eslint-disable-next-line import/no-extraneous-dependencies
    var supportsColor = supportsColor_1;

    if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
      exports.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221];
    }
  } catch (error) {// Swallow - we only care if `supports-color` is available; it doesn't have to be.
  }
  /**
   * Build up the default `inspectOpts` object from the environment variables.
   *
   *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
   */


  exports.inspectOpts = Object.keys(process.env).filter(function (key) {
    return /^debug_/i.test(key);
  }).reduce(function (obj, key) {
    // Camel-case
    var prop = key.substring(6).toLowerCase().replace(/_([a-z])/g, function (_, k) {
      return k.toUpperCase();
    }); // Coerce string value into JS value

    var val = process.env[key];

    if (/^(yes|on|true|enabled)$/i.test(val)) {
      val = true;
    } else if (/^(no|off|false|disabled)$/i.test(val)) {
      val = false;
    } else if (val === 'null') {
      val = null;
    } else {
      val = Number(val);
    }

    obj[prop] = val;
    return obj;
  }, {});
  /**
   * Is stdout a TTY? Colored output is enabled when `true`.
   */

  function useColors() {
    return 'colors' in exports.inspectOpts ? Boolean(exports.inspectOpts.colors) : tty.isatty(process.stderr.fd);
  }
  /**
   * Adds ANSI color escape codes if enabled.
   *
   * @api public
   */


  function formatArgs(args) {
    var name = this.namespace,
        useColors = this.useColors;

    if (useColors) {
      var c = this.color;
      var colorCode = "\x1B[3" + (c < 8 ? c : '8;5;' + c);
      var prefix = "  ".concat(colorCode, ";1m").concat(name, " \x1B[0m");
      args[0] = prefix + args[0].split('\n').join('\n' + prefix);
      args.push(colorCode + 'm+' + module.exports.humanize(this.diff) + "\x1B[0m");
    } else {
      args[0] = getDate() + name + ' ' + args[0];
    }
  }

  function getDate() {
    if (exports.inspectOpts.hideDate) {
      return '';
    }

    return new Date().toISOString() + ' ';
  }
  /**
   * Invokes `util.format()` with the specified arguments and writes to stderr.
   */


  function log() {
    return process.stderr.write(util.format.apply(util, arguments) + '\n');
  }
  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */


  function save(namespaces) {
    if (namespaces) {
      process.env.DEBUG = namespaces;
    } else {
      // If you set a process.env field to null or undefined, it gets cast to the
      // string 'null' or 'undefined'. Just delete instead.
      delete process.env.DEBUG;
    }
  }
  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */


  function load() {
    return process.env.DEBUG;
  }
  /**
   * Init logic for `debug` instances.
   *
   * Create a new `inspectOpts` object in case `useColors` is set
   * differently for a particular `debug` instance.
   */


  function init(debug) {
    debug.inspectOpts = {};
    var keys = Object.keys(exports.inspectOpts);

    for (var i = 0; i < keys.length; i++) {
      debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
    }
  }

  module.exports = common(exports);
  var formatters = module.exports.formatters;
  /**
   * Map %o to `util.inspect()`, all on a single line.
   */

  formatters.o = function (v) {
    this.inspectOpts.colors = this.useColors;
    return util.inspect(v, this.inspectOpts).replace(/\s*\n\s*/g, ' ');
  };
  /**
   * Map %O to `util.inspect()`, allowing multiple lines if needed.
   */


  formatters.O = function (v) {
    this.inspectOpts.colors = this.useColors;
    return util.inspect(v, this.inspectOpts);
  };
});
var node_1 = node.init;
var node_2 = node.log;
var node_3 = node.formatArgs;
var node_4 = node.save;
var node_5 = node.load;
var node_6 = node.useColors;
var node_7 = node.colors;
var node_8 = node.inspectOpts;

var src = createCommonjsModule(function (module) {
  /**
   * Detect Electron renderer / nwjs process, which is node, but we should
   * treat as a browser.
   */
  if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
    module.exports = browser;
  } else {
    module.exports = node;
  }
});

/**
 * Throttling enforces a maximum number of times a function can be called over time. As in “execute this function at most once every X milliseconds.”.
 * see http://demo.nimius.net/debounce_throttle/
 *
 * @param {function} fn throttled function
 * @param {integer} limit in milliseconds
 */
function throttle (fn) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var wait = false;
  var result;
  return function
    /* ...args */
  () {
    if (wait === false) {
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
      result = fn.apply(this, arguments); // eslint-disable-line
    }

    return result;
  };
}

var hotspotsMixin = {
  props: {
    hotspots: {
      type: Array
    }
  },
  computed: {
    htmlIconHotspots: function htmlIconHotspots() {
      var _this = this;

      return this.hotspots && this.hotspots.filter(function (item) {
        return item.shape === 'rect' && (_this.$xp.settings.mergedSettings.navigation.imageMapDefaultIcon && item.icon !== '' || !_this.$xp.settings.mergedSettings.navigation.imageMapDefaultIcon && item.icon > '');
      }).map(function (item) {
        return {
          centerYPercent: (item.tl.y + item.br.y) / 2 / 100,
          centerXPercent: (item.tl.x + item.br.x) / 2 / 100,
          alt: item.alt,
          href: item.href,
          route: item.href,
          icon: item.icon || 'default',
          icontext: item.icontext ? item.icontext : ''
        };
      });
    },
    svgHotspots: function svgHotspots() {
      var filteredHotsposts = this.hotspots && this.hotspots.filter(function (item) {
        return item.icon === '' || item.icon === undefined;
      });
      console.log('filteredHotsposts', filteredHotsposts);
      return filteredHotsposts;
    }
  },
  created: function created() {
    this.hotspotClicked = throttle(this.hotspotClicked);
    this.hotspotIconClicked = throttle(this.hotspotIconClicked);
  },
  methods: {
    checkForHotspot: function checkForHotspot(coords) {
      var _this2 = this;

      this.hotspots.map(function (hotspot) {
        switch (hotspot.shape) {
          case 'poly':
            if (_this2.isInPolyHotspot(coords, hotspot)) {
              _this2.hotspotClicked(hotspot);

              return true;
            }

            break;

          case 'circle':
            if (_this2.isInCircleHotspot(coords, hotspot)) {
              _this2.hotspotClicked(hotspot);

              return true;
            }

            break;

          case 'rect':
            if (_this2.isInRectHotspot(coords, hotspot)) {
              _this2.hotspotClicked(hotspot);

              return true;
            }

            break;
        }
      });
    },
    isInCircleHotspot: function isInCircleHotspot(point, hotspot) {
      return Math.sqrt(Math.pow(point[0] - hotspot.center.x, 2) + Math.pow(point[1] - hotspot.center.y, 2)) <= hotspot.radius;
    },
    isInRectHotspot: function isInRectHotspot(point, hotspot) {
      return point[0] >= hotspot.tl.x && point[0] <= hotspot.br.x && point[1] > hotspot.tl.y && point[1] <= hotspot.br.y;
    },
    isInPolyHotspot: function isInPolyHotspot(point, hotspot) {
      var vs = hotspot.points.map(function (point) {
        return [point.x, point.y];
      });
      var x = point[0];
      var y = point[1];
      var inside = false;

      for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0];
        var yi = vs[i][1];
        var xj = vs[j][0];
        var yj = vs[j][1];
        var intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    },
    hotspotClicked: function hotspotClicked(hotspot) {
      this.$emit('hotspot-click', hotspot);
    },
    hotspotIconClicked: function hotspotIconClicked(hotspotHref) {
      this.$emit('hotspot-click', {
        href: hotspotHref.replace('#', '')
      });
    }
  }
};

var listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
}; // feature detection for event listener options

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: {
          passive: true
        },
        notPassive: {
          passive: false
        },
        passiveCapture: {
          passive: true,
          capture: true
        },
        notPassiveCapture: {
          passive: false,
          capture: true
        }
      });
    }
  });
  window.addEventListener('xptest', null, opts);
  window.removeEventListener('xptest', null, opts);
} catch (e) {}
function position(e) {
  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  } else if (e.targetTouches && e.targetTouches[0]) {
    e = e.targetTouches[0];
  }

  return {
    top: e.clientY,
    left: e.clientX
  };
}

var dragDetector = {
  date: function date() {
    return {
      isDragged: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.onStart = throttle(function (e) {
      _this.isDown = true;
      _this.startTime = Date.now();
      _this.isDragged = false;
      _this.startPosition = position(e);
    });
    this.onEnd = throttle(function () {
      _this.isDown = false;
    });
    this.onMove = throttle(function (e) {
      if (_this.isDown) {
        var currentPosition = position(e);
        var dX = Math.abs(_this.startPosition.top - currentPosition.top);
        var dY = Math.abs(_this.startPosition.left - currentPosition.left);

        if (dX >= 3 || dY >= 3 || Date.now() - _this.startTime > 800) {
          _this.isDragged = true;
        }
      }
    });
    document.addEventListener('touchstart', this.onStart);
    document.addEventListener('mousedown', this.onStart);
    document.addEventListener('touchmove', this.onMove);
    document.addEventListener('mousemove', this.onMove);
    document.addEventListener('touchend', this.onEnd);
    document.addEventListener('mouseup', this.onEnd);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('touchstart', this.onStart);
    document.removeEventListener('mousedown', this.onStart);
    document.removeEventListener('touchmove', this.onMove);
    document.removeEventListener('mousemove', this.onMove);
    document.removeEventListener('touchend', this.onEnd);
    document.removeEventListener('mouseup', this.onEnd);
  }
};

var XpImg = Vue.extend({
  name: 'XpImg',
  mixins: [hotspotsMixin, dragDetector],
  props: {
    src: String,
    alt: String,
    width: Number,
    height: Number,
    placeholderSrc: String
  },
  data: function data() {
    return {
      currentSrc: '',
      image: null,
      isLoading: !!this.src,
      isComplete: false,
      // Preview wurde durch Vollversion ersetzt. Alles fertig.
      hasError: false,
      naturalRatio: undefined,
      svgImageBoundingClientRect: null,
      xpImageBoundingClientRect: null,
      imageID: 'i' + Math.random().toString(16).slice(2),
      iconSize: this.$xp.content.pageData.IconSize ? this.$xp.content.pageData.IconSize : 100 // Größe ImageMap-Icons in %

    };
  },
  watch: {
    src: function src() {
      this.__load();
    }
  },
  computed: {
    url: function url() {
      return this.currentSrc || this.placeholderSrc || undefined;
    },
    style: function style() {
      return {
        width: Number(this.width),
        height: Number(this.height),
        backgroundImage: 'url(' + this.url + ')'
      };
    }
  },
  created: function created() {
    var _this = this;

    this.screenUnwatcher = this.$watch(function () {
      return [// this.$xp.screen.orientation,
      _this.$xp.screen.width, _this.$xp.screen.height].join();
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$nextTick();

            case 2:
              setTimeout(function () {
                _this.__updateImageBoundingRect();
              }, 0);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log('XpImg mounted', this.$el);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          _this2.__updateImageBoundingRect();
        }
      });
    }, {});
    observer.observe(this.$el);
  },
  methods: {
    __onLoad: function __onLoad(img) {
      this.isLoading = false;
      this.hasError = false;

      this.__computeRatio(img);

      this.__updateSrc();

      this.__updateImageBoundingRect();

      this.$emit('load', this.currentSrc);
    },
    __updateImageBoundingRect: function __updateImageBoundingRect() {
      this.xpImageBoundingClientRect = this.$el.getBoundingClientRect().toJSON();
      this.svgImageBoundingClientRect = this.$el.querySelector('svg image') ? this.$el.querySelector('svg image').getBoundingClientRect().toJSON() : null;
    },
    __onError: function __onError(err) {
      console.warn(err);
      this.isLoading = false;
      this.hasError = true;
      this.currentSrc = '';
      this.$emit('error', err);
    },
    __updateSrc: function __updateSrc() {
      var _this3 = this;

      if (this.image !== undefined && this.isLoading === false) {
        var src = this.image.currentSrc || this.image.src;

        if (this.currentSrc !== src) {
          this.currentSrc = src;
          setTimeout(function () {
            // Timeout, da sonst Bild einen winzigen Moment in Thumbnail-Size zu sehen ist
            _this3.isComplete = true;
          }, 50);
        }
      }
    },
    __load: function __load() {
      var _this4 = this;

      this.hasError = false;

      if (!this.src) {
        this.isLoading = false;
        this.image = undefined;
        this.currentSrc = '';
        return;
      }

      this.isLoading = true;
      var img = new Image();
      this.image = img;
      this.$xp.http.getFileUrl(this.src).then(function (data) {
        if (_this4.destroyed === true) {
          return;
        }

        img.src = data; // if we are still rendering same image

        if (_this4.image === img) {
          _this4.__onLoad(img);
        }
      }).catch(function (error) {
        // if we are still rendering same image
        if (_this4.image === img && _this4.destroyed !== true) {
          _this4.__onError(error);
        }
      });
      Object.assign(img, {
        height: this.height,
        width: this.width
      });
    },
    __hotspotClickHandler: function __hotspotClickHandler(event) {
      var coords = position(event);
      var bb = event.target.getBoundingClientRect();
      this.checkForHotspot([(coords.left - bb.left) / bb.width * 100, (coords.top - bb.top) / bb.height * 100]);
    },
    __computeRatio: function __computeRatio(img) {
      var _this5 = this;

      var naturalHeight = img.naturalHeight,
          naturalWidth = img.naturalWidth;

      if (naturalHeight || naturalWidth) {
        this.naturalRatio = naturalHeight === 0 ? 1 : naturalWidth / naturalHeight;
      } else {
        this.ratioTimer = setTimeout(function () {
          if (_this5.image === img && _this5.destroyed !== true) {
            _this5.__computeRatio(img);
          }
        }, 100);
      }
    }
  },
  render: function render(h) {
    var _this6 = this;

    if (this.width && this.height && this.hotspots.length) {
      return h('div', {
        staticClass: 'xp-img',
        style: this.style
      }, [h('div', {
        staticClass: 'xp-img__background-cover'
      }), h('svg', {
        attrs: {
          width: '100%',
          height: '100%',
          viewBox: "0, 0, ".concat(this.width, ", ").concat(this.height),
          version: '1.1',
          'xmlns:xlink': 'http://www.w3.org/1999/xlink',
          role: 'img',
          'aria-labelledby': "binarylabel".concat(this.imageID)
        }
      }, [h('title', {
        attrs: {
          id: "binarylabel".concat(this.imageID)
        }
      }, this.alt), h('image', {
        attrs: {
          width: this.width,
          height: this.height,
          'xlink:href': this.url,
          'data-binary-src': this.src
        }
      })].concat(_toConsumableArray(this.svgHotspots.map(function (hotspot) {
        _this6.hotspotShapAttrs = function () {
          switch (hotspot.shape) {
            case 'rect':
              return {
                width: (hotspot.br.x - hotspot.tl.x) * _this6.width / 100,
                height: (hotspot.br.y - hotspot.tl.y) * _this6.height / 100,
                x: hotspot.tl.x * _this6.width / 100,
                y: hotspot.tl.y * _this6.height / 100
              };

            case 'circle':
              return {
                cx: hotspot.center.x * _this6.width / 100,
                cy: hotspot.center.y * _this6.height / 100,
                r: hotspot.radius * _this6.width / 100
              };

            case 'polygon':
            case 'poly':
              {
                var coords = [];
                hotspot.points.map(function (point) {
                  coords.push(point.x * _this6.width / 100 + ',' + point.y * _this6.height / 100);
                });
                return {
                  points: coords.join(' ')
                };
              }
          }
        }();

        return h(hotspot.shape === 'poly' ? 'polygon' : hotspot.shape, {
          staticClass: 'xp-img__svg-path',
          on: {
            touchend: function touchend(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            },
            mouseup: function mouseup(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            }
          },
          attrs: Object.assign({
            fill: 'transparent',
            'aria-hidden': true
          }, _this6.hotspotShapAttrs)
        }, []);
      }))))].concat(_toConsumableArray(!this.isLoading ? this.htmlIconHotspots.map(function (hotspot) {
        return h('button', {
          class: "xp xp--large xp-img__hotspot-icon xp-img__hotspot-icon--".concat(hotspot.icon),
          style: {
            top: ((_this6.xpImageBoundingClientRect.height - _this6.svgImageBoundingClientRect.height) / 2 + hotspot.centerYPercent * _this6.svgImageBoundingClientRect.height) / _this6.xpImageBoundingClientRect.height * 100 + '%',
            left: ((_this6.xpImageBoundingClientRect.width - _this6.svgImageBoundingClientRect.width) / 2 + hotspot.centerXPercent * _this6.svgImageBoundingClientRect.width) / _this6.xpImageBoundingClientRect.width * 100 + '%',
            borderRadius: 0.333334 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem',
            borderWidth: 2 / window.devicePixelRatio * _this6.iconSize / 100 + 'px',
            height: 4 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem',
            margin: -2 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem' + ' 0 0 -' + 3 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem',
            width: 6 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem',
            fontSize: (hotspot.icon === 'display' ? 2.75 / window.devicePixelRatio * _this6.iconSize / 100 : 5 / window.devicePixelRatio * _this6.iconSize / 100) + 'rem',
            paddingTop: hotspot.icon === 'display' ? 0.35 / window.devicePixelRatio * _this6.iconSize / 100 + 'rem' : '0'
          },
          attrs: {
            href: hotspot.href,
            title: hotspot.alt === '' || hotspot.alt === undefined ? '' : hotspot.alt,
            role: 'link'
          },
          on: {
            touchend: function touchend(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            },
            mouseup: function mouseup(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            }
          }
        }, hotspot.icon === 'display' && hotspot.icontext ? hotspot.icontext : '');
      }) : []), _toConsumableArray(this.svgHotspots.map(function (hotspot) {
        return h('span', {
          on: {
            touchend: function touchend(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            },
            mouseup: function mouseup(e) {
              if (!_this6.isDragged) {
                if (e.cancelable === true) e.preventDefault();

                _this6.hotspotClicked(hotspot);
              }
            }
          },
          class: 'sr-only',
          attrs: Object.assign({
            role: 'link',
            title: hotspot.alt === '' || hotspot.alt === undefined ? '' : hotspot.alt,
            tabindex: 0,
            fill: 'transparent'
          }, _this6.hotspotShapAttrs)
        }, []);
      }))));
    }

    return h('div', {
      class: 'xp-img',
      style: this.style
    }, [h('div', {
      staticClass: 'xp-img__background-cover'
    }), h('img', {
      staticClass: 'xp-img__image',
      class: !this.isComplete ? 'preview' : '',
      attrs: {
        src: this.url,
        'data-binary-src': this.src,
        alt: this.alt === '' || this.alt === undefined ? this.$xp.content.pageData.Title : this.alt
      },
      style: {
        filter: this.isLoading ? 'blur(10px)' : null
      },
      on: this.hotspots !== undefined && this.hotspots.length > 0 ? _objectSpread2(_objectSpread2({}, this.$listeners), {}, {
        mouseup: this.__hotspotClickHandler,
        touchend: this.__hotspotClickHandler
      }) : this.$listeners // , 'touchend': this.__getHotspotLister(), 'mouseup': this.__getHotspotLister()}

    })]);
  },
  beforeMount: function beforeMount() {
    var _this7 = this;

    if (this.placeholderSrc !== undefined) {
      var img = new Image();
      img.src = this.placeholderSrc;

      img.onload = function () {
        _this7.__computeRatio(img);
      };
    }

    this.isLoading === true && this.__load();
    console.log('beforeMount', this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyed = true;
    this.screenUnwatcher();
    this.isLoading && this.$xp.http.cancelRequest(this.src);
    this.image.src = ''; // to abort loading
  }
});

var vm = new Vue();
var handleExternalUrl = function handleExternalUrl(url) {
  if (vm.$xp.device.isLoan) {
    console.log('should show dialog, device is loan and external url is clicked, this functionality is not permitted on loan devices'); // window.navigator.notification.alert(vm.$t('global.externalUrlLoanHinweis'), () => { console.log('No External Url alertOnLoan Callback.') }, vm.$t('global.error'), vm.$t('global.continue'))
  } else if (vm.$xp.device.platform === 'browser') {
    window.open(url, 'tab');
  } else if (vm.$xp.device.platform === 'android' || vm.$xp.device.platform === 'ios') {
    if (window.cordova && window.cordova.InAppBrowser) {
      window.cordova.InAppBrowser.open(url, '_system');
    }
  }
};
var getXpedeoPrefixUrlPageId = function getXpedeoPrefixUrlPageId(url) {
  url = url.replace('xpedeo://', '');
  var pageId = null;

  switch (url) {
    case 'LastPanoramaID':
      {
        var lastPanoramaPageId = vm.$xp.history.getLastPanoramaPage(vm.$xp.history.lastHomePage.pageId);
        var defaultPanoramaPageId = vm.$xp.content.pageData.Homepage ? vm.$xp.content.pageData.Homepage.DefaultPanoramaPageID : null;
        pageId = lastPanoramaPageId || defaultPanoramaPageId;
      }
      break;

    case 'next':
      pageId = url;
      break;

    default:
      if (url.includes('preload')) {
        pageId = url;
      }

      break;
  }

  return pageId;
}; // to-do : refactor to take care of types

var handleUrl = function handleUrl(url, router) {
  var isTab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (typeof url === 'string' && url.startsWith('xpedeo://')) {
    var pageId = getXpedeoPrefixUrlPageId(url);

    if (pageId) {
      if (typeof pageId === 'string' && pageId.includes('preload')) {
        console.log('switch to preload page');
        var urlParts = pageId.split('/').filter(function (i) {
          return i;
        });
        console.log('urlparts ', urlParts); // preloadModules = urlParts[0]
        // console.log()

        var nextPageId = urlParts[1].replace('NID=', '');
        console.log(urlParts);
        window.localStorage.setItem('preloadNextPageId', nextPageId); // router.push('/preload/' + urlParts[0])

        console.log('isOnline', vm.$xp.network.isOnline);

        if (!vm.$xp.network.isOnline) {
          console.log('Offline, cannot preload'); // window.navigator.notification.alert(vm.$t('global.errorOffline'))
        } else {
          vm.$xp.content.showPreloadModal = true;
        }

        vm.$xp.content.preloadPath = urlParts[0];
      } else if (typeof pageId === 'string' && pageId === 'next') {
        if (vm.$xp.content.pageData.NextPageID) {
          router.push('/page/' + vm.$xp.content.pageData.NextPageID);
        } else {
          console.warn('Splash screen has no next page');
        }
      } else if (isTab) {
        !router.history.current.path.includes(pageId) && router.replace({
          path: "/page/".concat(pageId),
          query: {
            replace: true
          }
        });
      } else {
        router.push("/page/".concat(pageId));
      }
    } else {
      console.error('Cannot determine pageId from Url: ', url);
    }
  } else if (isTab) {
    if (!router.history.current.path.includes(url)) {
      vm.$xp.navigation.setActiveTabId(url);
      router.replace({
        path: "/page/".concat(url),
        query: {
          replace: true
        }
      });
    }
  } else if (typeof url === 'string' && url.startsWith('http')) {
    handleExternalUrl(url);
  } else if (typeof url === 'string' && (url.startsWith('/page/') || url.startsWith('#/page/'))) {
    if (url.startsWith('#/page/')) url = url.replace('#', '');
    router.push(url);
  } else if (typeof url === 'string' && url.startsWith('/lang')) {
    var urls = url.split('/'); // e.g : /lang/en_EN/en/page/xxxx

    var langIndex = url.indexOf('lang');
    var langCode = urls[langIndex + 1];
    var langPath = urls[langIndex + 2];
    var _pageId = urls[langIndex + 4];
    console.log(urls);
    window.localStorage.setItem('nfcLangCode', langCode);
    vm.$xp.polyglot.setLanguage(langCode, langPath);
    router.push("/page/".concat(_pageId));
  }
};

var EventHub = {
  Bus: new Vue(),
  TYPES: {
    RE_INIT_IMAGE_MAP: 're-initialize-image-map',
    START_PLAY_MEDIA: 'start-play-media',
    ANDROID_ACTIVITY_PAUSE: 'android-activity-pause',
    CLICKED_HOTSPOT_SPLASHSCREEN: 'clicked_hotspot_splashscreen'
  }
};

var log = src('xpedeo-core:ImageEntry');
src.enable(process.env.VUE_APP_DEBUG);
var script$1 = {
  mixins: [entry],
  components: {
    PanzoomMap: __vue_component__,
    XpImg: XpImg
  },
  props: {
    mode: {
      type: String,
      default: 'image',
      validator: function validator(value) {
        if (['map', 'image'].includes(value)) {
          return true;
        } else {
          console.warn('ImageEntry: mode property can either be "map" or "image');
          return false;
        }
      }
    }
  },
  computed: {
    imageUrl: function imageUrl() {
      // eslint-disable-next-line no-unused-expressions
      this.shouldRecomputeImageVariables;
      return this.$xp.content.getImageUrl(this.entryData.Image, this.mode === 'map' ? 0 : this.imageWidth);
    },
    zoomImageUrl: function zoomImageUrl() {
      // eslint-disable-next-line no-unused-expressions
      this.shouldRecomputeImageVariables;
      return this.$xp.content.getImageUrl(this.entryData.Image, 0);
    },
    imageHeight: function imageHeight() {
      // eslint-disable-next-line no-unused-expressions
      this.shouldRecomputeImageVariables;
      return this.mode === 'map' ? Number(this.entryData.Image.Height) : Math.round(this.imageWidth / this.entryData.Image.Width * this.entryData.Image.Height);
    },
    imageWidth: function imageWidth() {
      // eslint-disable-next-line no-unused-expressions
      this.shouldRecomputeImageVariables;
      return this.mode === 'map' ? this.entryData.Image.Width : this.$xp.content.getRequiredImageWidth(this.entryData.Image);
    } //  this.imageWidth = this.$xp.content.getRequiredImageWidth(this.entryData.Image)
    //         this.imageHeight = Math.round(this.imageWidth / Number(this.entryData.Image.Width) * Number(this.entryData.Image.Height))
    //         this.imageUrl = this.$xp.content.getImageUrl(this.entryData.Image, this.imageWidth)

  },
  data: function data(vm) {
    return {
      isCaptionActive: false,
      isZoomDialogActive: false,
      // imageWidth: vm.mode === 'map' ? Number(vm.entryData.Image.Width) : vm.$xp.content.getRequiredImageWidth(vm.entryData.Image),
      // imageHeight: vm.mode === 'map' ? Number(vm.entryData.Image.Height) : Math.round(vm.imageWidth / vm.entryData.Image.Width * vm.entryData.Image.Height),
      // imageUrl: null,
      // zoomImageUrl: null,
      // imageUrlData: null,
      ScaleToScreenHeight: this.entryData.ScaleToScreenHeight,
      shouldRecomputeImageVariables: 0 // this is a hack to force recompute of image variables see : https://logaretm.com/blog/forcing-recomputation-of-computed-properties/

    };
  },
  created: function created() {
    // EventHub.Bus.$on(EventHub.TYPES.RE_INIT_IMAGE_MAP, this.initImageMap)
    log('created', this.ScaleToScreenHeight);
    this.onAreaClick = throttle(this.onAreaClick); // this.imageWidth = this.mode === 'map' ? this.entryData.Image.Width : this.$xp.content.getRequiredImageWidth(this.entryData.Image)
    // this.imageHeight = this.mode === 'map' ? Number(this.entryData.Image.Height) : Math.round(this.imageWidth / this.entryData.Image.Width * this.entryData.Image.Height)
    // this.imageUrl = this.$xp.content.getImageUrl(this.entryData.Image, this.mode === 'map' ? 0 : this.imageWidth)
    // this.zoomImageUrl = this.$xp.content.getImageUrl(this.entryData.Image, 0)
    // this.$xp.navigation.checkScreenReader().then(() => {

    if (this.$xp.navigation.isScreenReader) this.isCaptionActive = true; // })
  },
  mounted: function mounted() {
    var _this = this;

    if (this.entryData.Json.Href && this.entryData.Json.Href.length > 0 && !this.entryData.Json.ImageMap.length) {
      this.$el.querySelector('.xp-img img').addEventListener('click', function () {
        handleUrl(_this.entryData.Json.Href, _this.$router);
      });
    }
  },
  methods: {
    onAreaClick: function onAreaClick(hotspot) {
      console.log('onAreaClick');

      if (this.pageData.Class === 'XpSplashScreen') {
        EventHub.Bus.$emit(EventHub.TYPES.CLICKED_HOTSPOT_SPLASHSCREEN);
      }

      if (hotspot.href.length > 0) {
        handleUrl(hotspot.href, this.$router);
      } else if (hotspot.route && hotspot.route.length > 0 && hotspot.route.startsWith('/page/')) {
        this.$router.push(hotspot.route);
      }
    },
    onCaptionClick: function onCaptionClick() {
      this.isCaptionActive = !this.isCaptionActive;
    },
    onZoomDialogClick: function onZoomDialogClick() {
      var _this2 = this;

      if (!this.isZoomDialogActive) {
        this.$xp.navigation.hideNav();
        this.$xp.navigation.preventAutoHide();
        this.isZoomDialogActive = true;
        this.$xp.media.setIsImageZoomDialogActive(true);
      } else {
        this.isZoomDialogActive = false;
        this.$xp.media.setIsImageZoomDialogActive(false);
        setTimeout(function () {
          _this2.$xp.navigation.allowAutoHide();

          _this2.$xp.navigation.showNav(true);
        }, 200);
      }
    }
  },
  watch: {
    '$xp.screen.orientation': {
      handler: function handler() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // await this.$nextTick()
                  _this3.shouldRecomputeImageVariables++; // if (this.mode !== 'map') {
                  //   setTimeout(() => {
                  //     this.imageWidth = this.$xp.content.getRequiredImageWidth(this.entryData.Image)
                  //     this.imageHeight = Math.round(this.imageWidth / Number(this.entryData.Image.Width) * Number(this.entryData.Image.Height))
                  //     this.imageUrl = this.$xp.content.getImageUrl(this.entryData.Image, this.imageWidth)
                  //   }, 1000)
                  // }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
    },
    '$xp.navigation.isScreenReader': {
      handler: function handler() {
        var _this4 = this;

        return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
          return regenerator.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (_this4.$xp.navigation.isScreenReader) _this4.isCaptionActive = true;

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: {
        "js-entry": true,
        "o-entry": true,
        "c-image-entry": true,
        "c-image-entry--map-mode": _vm.mode === "map",
        "scale-to-screenheight": this.ScaleToScreenHeight
      }
    },
    [
      _c(
        "div",
        { staticClass: "c-image-entry__view" },
        [
          _c("xp-img", {
            attrs: {
              src: _vm.imageUrl,
              width: _vm.imageWidth,
              height: _vm.imageHeight,
              hotspots: _vm.entryData.Json.ImageMap || [],
              alt: _vm.entryData.Image.Alt,
              placeholderSrc: _vm.entryData.Image.Thumb
            },
            on: { "hotspot-click": _vm.onAreaClick }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "c-image-entry__btns": true,
            "is-hidden": _vm.$xp.navigation.isNavHidden
          }
        },
        [
          _vm.entryData.Json.Link2FullSize
            ? _c(
                "button",
                {
                  class: {
                    "c-image-entry__zoom-btn": true,
                    "js-zoom-dialog": true
                  },
                  attrs: { "aria-hidden": "true" },
                  on: { click: _vm.onZoomDialogClick }
                },
                [
                  _c("span", {
                    staticClass: "xp xp-zoom-in xp--large",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.entryData.Json.Caption && _vm.entryData.Json.Caption.length > 0
            ? _c(
                "button",
                {
                  class: {
                    "c-image-entry__caption-btn": true,
                    "js-caption": true
                  },
                  attrs: {
                    "aria-label": _vm.$t(
                      _vm.isCaptionActive
                        ? "global.srHideImageInfo"
                        : "global.srShowImageInfo"
                    )
                  },
                  on: { click: _vm.onCaptionClick }
                },
                [
                  _c("span", {
                    staticClass: "xp xp-information xp--large",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.entryData.Json.Caption && _vm.entryData.Json.Caption.length > 0
        ? _c(
            "div",
            {
              class: {
                "c-image-entry__caption": true,
                "js-caption": true,
                "c-image-entry__caption--overlay": true,
                "c-image-entry__caption--overlay--active": _vm.isCaptionActive
              },
              attrs: {
                "aria-label": _vm.$t(
                  _vm.isCaptionActive
                    ? "global.srHideImageInfo"
                    : "global.srShowImageInfo"
                )
              },
              on: { click: _vm.onCaptionClick }
            },
            [_vm._v("\n    " + _vm._s(_vm.entryData.Json.Caption) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Link2FullSize
        ? _c(
            "transition",
            {
              attrs: {
                "enter-active-class": "animated fadeIn",
                "leave-active-class": "animated fadeOut",
                mode: "out-in",
                duration: 200
              }
            },
            [
              _vm.isZoomDialogActive
                ? _c(
                    "div",
                    { class: { "c-image-entry__zoom-dialog": true } },
                    [
                      _c(
                        "panzoom-map",
                        {
                          attrs: {
                            height: _vm.entryData.Image.Height,
                            width: _vm.entryData.Image.Width,
                            "start-center": {
                              x: _vm.entryData.Image.Width / 2,
                              y: _vm.entryData.Image.Height / 2
                            }
                          }
                        },
                        [
                          _c("xp-img", {
                            attrs: {
                              src: _vm.zoomImageUrl,
                              hotspots: [],
                              placeholderSrc: _vm.entryData.Image.Thumb
                            },
                            on: {
                              mousedown: function($event) {
                                $event.preventDefault();
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-image-entry__zoom-btn",
                          on: { click: _vm.onZoomDialogClick }
                        },
                        [
                          _c("span", {
                            staticClass: "xp xp-close xp--large",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__$1;
//# sourceMappingURL=ImageEntry.js.map
